import React, { memo, useMemo } from 'react';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import Loading from '@gp/components/Loading';
import './index.scss';
import DEFAULT_GAME from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import DEFAULT_FLAG from '@gp/assets/svg/flag-default.svg';

interface DetailsHeaderConPropsType {
  style?: React.CSSProperties;
  isHideHeader: boolean;
  loading: boolean;
  data: any;
}

const DEFAULT_PROPS: DetailsHeaderConPropsType = {
  style: {},
  isHideHeader: false,
  loading: true,
  data: null,
};

function DetailsHeaderCon(props: DetailsHeaderConPropsType) {
  const { style, isHideHeader, loading, data } = props;

  const {
    img_url,
    name,
    national_flag,
    location_city,
    location_country,
    total,
  } = data || {};

  const tags: string[] = useMemo(() => {
    const temp = data?.genre?.split(',');
    return Array.isArray(temp) && temp?.length ? temp : [];
  }, [data]);

  return !loading ? (
    <div
      className="dbg-details-header-content"
      style={{ display: isHideHeader ? 'none' : 'flex', ...style }}
    >
      <div className="dbg-header-bg">
        <div
          className="dbg-header-bg-img"
          style={{
            backgroundImage: `url(${img_url || DEFAULT_GAME})`,
          }}
        ></div>
      </div>
      <GeneralImageNew
        domain="studio"
        width={72}
        height={72}
        className="header-img"
        src={img_url || ''}
      />
      <div className="header-info">
        <div className="header-title">
          <span className="title-text">{name || '-'}</span>
        </div>
        <div className="header-info-flex">
          <GeneralImageNew
            width={24}
            height={16}
            src={national_flag || ''}
            errorImg={DEFAULT_FLAG}
            borderRadius={0}
          />
          <span className="title-city-text">
            {location_city && location_country
              ? `${location_city}, ${location_country}`
              : '-'}
          </span>
        </div>

        <div className="header-sign">
          <label className="game-num-sign">{total || '0'} Games</label>
          {tags?.map((t: string) => {
            return t ? (
              <label key={t} className="game-type-sign">
                {t}
              </label>
            ) : null;
          })}
        </div>
      </div>
    </div>
  ) : (
    <Loading
      loading
      style={{
        height: 80,
        margin: '10px 0 8px 0',
        display: isHideHeader ? 'none' : '',
      }}
    />
  );
}

DetailsHeaderCon.defaultProps = DEFAULT_PROPS;

export default memo(DetailsHeaderCon);
